import React from 'react';
import { Box, Grid, Skeleton } from '@mui/material';

type WorkspacesSkeletonProps = {
  count?: number;
};
function MainInfoFormSkeleton({ count = 6 }: WorkspacesSkeletonProps) {
  const NO_OF_ITEMS_ARRAY: number[] = [];

  for (let i = 1; i <= count; i++) {
    NO_OF_ITEMS_ARRAY.push(i);
  }

  return (
    <Grid container width='100%' gap={1}>
      <Box width={'100%'} display='flex' gap={0.5}>
        <Skeleton
          variant='text'
          sx={{ fontSize: '0.7rem' }}
          width='25%'
          height='6rem'
        />
        <Skeleton
          variant='text'
          sx={{ fontSize: '0.7rem' }}
          width='25%'
          height='6rem'
        />
        <Skeleton
          variant='text'
          sx={{ fontSize: '0.7rem' }}
          width='25%'
          height='6rem'
        />
      </Box>
      <Box width='100%'>
        <Grid container spacing={2} paddingLeft={2}>
          <Skeleton
            variant='text'
            width='40%'
            height={60}
            sx={{ marginBottom: -2 }}
          />
          <Skeleton
            variant='text'
            width='100%'
            height={80}
            sx={{ marginBottom: -2 }}
          />
          <Skeleton
            variant='text'
            width='100%'
            height={200}
            sx={{ marginBottom: -2 }}
          />
        </Grid>
      </Box>
      <Box width='100%'>
        <Skeleton variant='rectangular' width='100%' height={2} />
      </Box>

      <Box width='100%'>
        <Grid container spacing={2} paddingLeft={2}>
          <Skeleton
            variant='text'
            width='40%'
            height={60}
            sx={{ marginBottom: -4, marginTop: 2 }}
          />
          <Skeleton
            variant='text'
            width='100%'
            height={200}
            sx={{ marginBottom: -2 }}
          />
        </Grid>
      </Box>

      <Box width='100%'>
        <Grid container spacing={2} paddingLeft={2}>
          <Skeleton
            variant='text'
            width='40%'
            height={60}
            sx={{ marginBottom: -4, marginTop: 2 }}
          />
        </Grid>
      </Box>
    </Grid>
  );
}

export default MainInfoFormSkeleton;
